import React from 'react';

import Card from '../Shared/Card.js';
import Details from '../Shared/Details.js';

import './Work.css';

const projects = [
  {
    title: 'Ounass',
    type: 'Development',
    url: 'https://www.ounass.ae',
    logo: 'ounass.jpg'
  }, {
    title: 'Our Heroes',
    type: 'Founder',
    url: 'https://ourheroes.io/',
    logo: 'our-heroes.jpg'
  }, {
    title: 'Gap',
    type: 'Development',
    url: 'https://www.gap.ae/',
    logo: 'gap.jpg'
  }, {
    title: 'Mamas & Papas',
    type: 'Development',
    url: 'https://www.mamasandpapas.ae/',
    logo: 'mamasandpapas.jpg'
  }, {
    title: 'Geeks',
    type: 'Re-Design & Development',
    url: 'https://www.geeks.ae',
    logo: 'geeks.jpg'
  }, {
    title: 'Stubble & Strife',
    type: 'Development',
    url: 'https://www.stubbleandstrife.com/',
    logo: 'stubbleandstrife.jpg'
  }, {
    title: 'HopScotch',
    type: 'Development',
    url: 'https://www.ilovehopscotch.com/',
    logo: 'hopscotch.jpg'
  }, {
    title: 'SegmentNext',
    type: 'Design & Development',
    url: 'https://segmentnext.com/',
    logo: 'segmentnext.jpg'
  }, {
    title: 'Vortex Creation',
    type: 'Design & Development',
    url: 'https://www.behance.net/gallery/22634175/Vortex-Creation',
    logo: 'vxcreation.jpg'
  }, {
    title: 'FEGroup',
    type: 'Development',
    url: 'http://fegroup.net.au/',
    logo: 'feggroup.jpg'
  }
];

class Work extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
      details: {}
    };
    this.showDetails = this.showDetails.bind(this)
    this.hideDetails = this.hideDetails.bind(this)
  }

  showDetails(props) {
    this.setState({
      showDetails: true,
      details: projects[props]
    });
  }

  hideDetails() {
    this.setState({ showDetails: false });
  }

  render() {
    return (
      <div className="app app-work">
        <h1 className="app-heading">Work {this.state.showDetails}</h1>

        <Card data={projects} showDetails={this.showDetails} />

        {this.state.showDetails ? <Details data={this.state.details} hideDetails={this.hideDetails} /> : null}
      </div>
    );
  }
}

export default Work;



// WEBPACK FOOTER //
// ./src/Pages/Work.js